<template>
  <main class="main page-inside products-page">
    <div class="main-wrapper">
      <div class="section shop-section">
        <div class="wrapper">
          <div class="title title-main">MARKET</div>
          <div class="topbar">
            <div class="title">FILTERS</div>
            <div class="search">
              <input
                type="text"
                placeholder="Search"
                v-model="searchedProductText"
                @keyup.enter="searchSubmit"
              />
              <a class="glass" @click="searchSubmit">
                <img src="../img/glass.svg" class="img" />
              </a>
            </div>
            <a class="desc link" @click="reset()">
              <span class="yellow">Reset all filters</span>
            </a>
          </div>
          <div class="shop-main">
            <div class="filters">
              <div class="sort">
                <div class="select-container" v-if="sortOptions.length">
                  <div class="desc">
                    <b>Sort by price:</b>
                  </div>
                  <Select2
                    class="select2 single"
                    v-model="sort"
                    :options="sortOptions"
                    placeholder="Sort by cheapest"
                    @select="selectSort($event)"
                  />
                </div>
              </div>
              <div class="filters-price">
                <div class="val-container">
                  <div class="val min">
                    <div class="desc cur">
                      {{ $parent.currency }}
                    </div>
                    <input
                      v-model="barMinValue"
                      type="number"
                      placeholder="min"
                    />
                  </div>
                  <div class="desc">-</div>
                  <div class="val max">
                    <div class="desc cur">
                      {{ $parent.currency }}
                    </div>
                    <input
                      v-model="barMaxValue"
                      type="number"
                      placeholder="max"
                    />
                  </div>
                </div>
              </div>
              <div class="filters-item" v-if="categories && categories.length">
                <div class="desc">
                  <b>Choosed type:</b>
                </div>
                <div class="select-container">
                  <label
                    class="chekbox-label"
                    v-for="(item, i) in categories"
                    :key="i"
                  >
                    <div class="chekbox-label-wrapper">
                      <input
                        type="checkbox"
                        v-model="activeCategory"
                        :value="item"
                        @input="checkActiveCategory"
                      />
                      <div class="checkbox"></div>
                      <span class="desc">
                        {{ item.text }}
                      </span>
                    </div>
                  </label>
                </div>
              </div>
            </div>
            <transition name="fade">
              <div
                class="product-list"
                v-if="productList.data && productList.data.length"
              >
                <div
                  class="item"
                  v-for="item in productList.data"
                  :key="item.id"
                  @click="openProductModal(item)"
                >
                  <img
                    src="../img/corners3/top-left-corner.svg"
                    class="top-left"
                  />
                  <img
                    src="../img/corners3/top-right-corner.svg"
                    class="top-right"
                  />
                  <img
                    src="../img/corners3/bottom-left-corner.svg"
                    class="bottom-left"
                  />
                  <img
                    src="../img/corners3/bottom-right-corner.svg"
                    class="bottom-right"
                  />
                  <span class="name desc big">{{ item.name }}</span>
                  <img :src="imgDomain + item.img + '.png'" class="img" />
                  <div class="bottom">
                    <div class="price-container">
                      <div class="price old-price">
                        <span class="title medium">
                          {{ item.old_price.toFixed(2) }}</span
                        >
                        <img src="../img/coin.svg" class="coin" />
                      </div>
                      <span class="price">
                        <span class="title medium amount">{{
                          item.price.toFixed(2)
                        }}</span>

                        <img src="../img/coin.svg" class="coin" />
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </transition>
            <transition name="fade">
              <div
                class="title no-products"
                v-if="productList.data && !productList.data.length"
              >
                <b>No products</b>
              </div>
            </transition>
          </div>
          <pagination
            v-if="totalProducts"
            v-model="activePage"
            :per-page="9"
            :records="totalProducts"
            @paginate="changePage"
          />
        </div>
      </div>
    </div>
  </main>
</template>
<script>
import Pagination from "vue-pagination-2";
import Select2 from "vue3-select2-component";

export default {
  name: "Products",
  props: ["currency", "currencyCode"],
  components: {
    Pagination,
    Select2,
  },
  data: function () {
    return {
      imgDomain: "",
      productList: [],
      activePage: 1,
      totalProducts: null,
      searchedProductText: "",
      activeCategory: [{ id: 0, text: "All" }],
      sort: "price",
      categories: [],
      sortOptions: [
        {
          id: "price",
          text: "Sort by cheapest",
        },
        {
          id: "-price",
          text: "Sort by expensive",
        },
      ],
      barMinValue: 0,
      barMaxValue: 1200,
    };
  },
  watch: {
    currencyCode: function () {
      this.filterProducts();
    },
    barMinValue: function () {
      console.log(4);
      this.activePage = 1;
      this.filterProducts();
    },
    barMaxValue: function () {
      this.activePage = 1;
      this.filterProducts();
    },
  },
  mounted() {
    this.imgDomain = process.env.VUE_APP_STATIC_DOMAIN;
    this.getCategories();
    this.$http
      .get(process.env.VUE_APP_API + "items")
      .then((res) => {
        this.productList = res.data;
        this.totalProducts = res.data.meta.total;
        this.filterProducts();
      })
      .catch((res) => {
        if (res.response.status === 401) {
          this.$parent.openSignInModal();
        }
      });
  },
  methods: {
    checkActiveCategory() {
      setTimeout(() => {
        let newVal = this.activeCategory;
        console.log(newVal);
        if (newVal.length > 1 && newVal[0].text === "All") {
          let newArr = newVal.filter((obj) => obj.text !== "All");
          this.activeCategory = newArr;
        } else if (
          newVal.length > 1 &&
          newVal[0].text !== "All" &&
          newVal.some((obj) => obj.text === "All")
        ) {
          let newArr = newVal.filter((obj) => obj.text === "All");
          this.activeCategory = newArr;
        } else if (newVal.length == 1 && newVal[0].text === "All") {
          this.activeCategory = [{ id: 0, text: "All" }];
        }
        this.filterProducts();
      }, 300);
    },
    reset() {
      this.activeCategory = [{ id: 0, text: "All" }];
      this.searchedProductText = "";
      this.changePage(1);

      window.scrollTo(0, 0);
    },
    getCategories() {
      this.$http
        .get(process.env.VUE_APP_API + "categories")
        .then((res) => {
          this.categories = res.data.payload.map(({ id, name, ...rest }) => ({
            id,
            text: name,
            ...rest,
          }));
          this.categories.unshift({ id: 0, text: "All" });
        })
        .catch((res) => {
          if (res.response.status === 401) {
            this.$parent.openSignInModal();
          }
        });
    },
    selectSort(event) {
      this.sort = event.id;
      this.filterProducts();
    },
    goToProduct(item) {
      this.$parent.goToProduct(item);
    },
    changePage(page) {
      this.activePage = page;
      this.filterProducts();
    },
    searchSubmit() {
      this.filterProducts();
    },
    filterProducts() {
      let addPrice =
        "&price_from=" + this.barMinValue + "&price_till=" + this.barMaxValue;
      let addSort = "sort=" + this.sort;
      let addPage = "&page=" + this.activePage;
      let addSearch = this.searchedProductText
        ? "&filter[name]=" + this.searchedProductText
        : "";
      let addcCategory;
      if (
        (this.activeCategory.length == 1 && this.activeCategory[0].id == 0) ||
        this.activeCategory == ""
      ) {
        addcCategory = "";
      } else {
        let newArr = this.activeCategory.map((item) => item.id);

        addcCategory = "&filter[category]=" + newArr;
      }
      this.$http
        .get(
          "items?" +
            addSort +
            addPage +
            addSearch +
            addPrice +
            addcCategory +
            "&per_page=9"
        )
        .then((res) => {
          this.productList = res.data;
          this.totalProducts = res.data.meta.total;
        })
        .catch(() => {});
    },
    openProductModal(product) {
      this.$emit("openProductModal", product);
    },
  },
};
</script>
